import styled from "styled-components";

const TrendingWrap = styled.div`
  padding: 0px 0px;
` 

export default TrendingWrap
